
import MIcon from "@/components/MIcon.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    MIcon
  },
  emits: ["delete"],
  props: {
    text: String
  }
})
export default class MReservationCard extends Vue {
  text = "";

  deleteData() {
    this.$emit("delete");
  }
}
